<template>
  <div>
    <Loader v-if="Object.keys(this.data).length === 0" />
    <div class="user-wrapper w-100" v-else>
      <profile-header></profile-header>
      <div class="user-content">
        <div class="container">
          <div class="my-auto w-100 main-area">
            <div class="profile-detail">
              <div class="profile-info-block" style="background:#f0f5f7">
                <div class="edit-block">
                  <button
                    class="btn btn-secondary rounded btn-sm font-18 editBtn"
                    v-b-tooltip
                    title="編集"
                    @click="showModal"
                  >
                    編集
                  </button>
                </div>
                <h2 class="rg-title">基本情報</h2>
                <div>
                  <table class="table">
                    <tbody>
                      <tr>
                        <th>氏名</th>
                        <td>
                          <span class="edit-txt">{{ profile.last_name }} {{ profile.full_name }}</span>
                          <!-- <div class="custom-form-block edit-custom" v-else> -->
                        </td>
                      </tr>
                      <tr>
                        <th>氏名（ふりがな）</th>
                        <td>
                          <span class="edit-txt">{{ profile.last_furigana }} {{ profile.furigana }}</span>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          性別
                        </th>
                        <td>
                          <span class="edit-txt">{{ profile.gender }}</span>
                        </td>
                      </tr>
                      <tr>
                        <th>生年月日</th>
                        <td>
                          <span class="edit-txt">{{ birthDate }}</span>
                        </td>
                      </tr>
                      <tr>
                        <th>居住地</th>
                        <td>
                          <span class="edit-txt">{{
                            getResidence(profile.residence)
                          }}</span>
                        </td>
                      </tr>
                      <tr>
                        <th>メールアドレス</th>
                        <td>
                          <span class="edit-txt">{{ profile.email }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- ends profile-detail-block -->

              <Academic :finalEducation="data.finalEducation" />

              <Employment :data="data" />

              <!-- ends profile-info-block -->
              <b-modal
                id="modal1"
                ref="modal"
                hide-footer
                size="lg"
                :no-close-on-esc="true"
                :no-close-on-backdrop="true"
              >
                <template #modal-header>
                  <!-- Emulate built in modal header close button action -->
                  <!-- <button type="button" class="close" aria-label="Close" v-on:click.prevent="cancel('sharing')">
                      <span aria-hidden="true">&times;</span>
                    </button> -->
                  <img
                    src="../assets/close.png"
                    v-on:click.prevent="cancel('personal')"
                    style="cursor:pointer;margin-top:5px"
                  />
                  <h5 class="sharingTitle" style="margin-top:5px">
                    基本情報
                  </h5>
                  <button
                    data-v-bf1681ae=""
                    title="保存"
                    class="btn btn-secondary rounded btn-sm font-16 editBtn"
                    @click.prevent="savePersonal"
                  >
                    保存
                  </button>
                </template>
                <form
                  v-on:submit.prevent="savePersonal"
                  data-vv-scope="personal"
                  style="max-height: 600px;overflow-y:scroll;"
                >
                  <div class="form-sep-block">
                    <div class="item-form-block">
                      <div class="form-group row">
                        <div class="col-md-6 mb-30">
                          <label class="cstm-label">
                            氏名
                            <span class="span-badge ml-2">必須</span>
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-bind:class="{
                              'is-invalid': hasError('last_name', 'personal'),
                            }"
                            name="last_name"
                            v-model="profile.last_name"
                            v-validate="'required|max:50'"
                            data-vv-as="姓"
                          />
                          <div
                            class="invalid-feedback"
                            v-if="hasError('last_name', 'personal')"
                          >
                             
                            {{ getErrorMessage("last_name", "personal") }}
                          </div>
                        </div>
                        <div class="col-md-6 mb-30">
                          <label class="cstm-label mobile-label">&nbsp;</label>
                          <input
                            type="text"
                            class="form-control "
                            v-bind:class="{
                              'is-invalid': hasError('full_name', 'personal'),
                            }"
                            name="full_name"
                            v-model="profile.full_name"
                            v-validate="'required|max:50'"
                            data-vv-as="名"
                          />
                          <div
                            class="invalid-feedback"
                            v-if="hasError('full_name', 'personal')"
                          >
                             
                            {{ getErrorMessage("full_name", "personal") }}
                          </div>
                        </div>
                        <div class="col-md-6 mb-30">
                          <label class="cstm-label">
                            氏名（ふりがな）
                            <span class="span-badge ml-2">必須</span>
                          </label>
                          <input
                            type="text"
                            class="form-control "
                            v-bind:class="{
                              'is-invalid': hasError(
                                'last_furigana',
                                'personal'
                              ),
                            }"
                            name="last_furigana"
                            v-model="profile.last_furigana"
                            v-validate="'required|max:50'"
                            data-vv-as="せい"
                          />
                          <div
                            class="invalid-feedback"
                            v-if="hasError('last_furigana', 'personal')"
                          >
                             
                            {{ getErrorMessage("last_furigana", "personal") }}
                          </div>
                        </div>
                        <div class="col-md-6 mb-30">
                          <label class="cstm-label mobile-label">
                            &nbsp;
                            <!-- <span class="text-danger">*</span> -->
                          </label>
                          <input
                            type="text"
                            class="form-control "
                            v-bind:class="{
                              'is-invalid': hasError('furigana', 'personal'),
                            }"
                            name="furigana"
                            v-model="profile.furigana"
                            v-validate="'required|max:50'"
                            data-vv-as="めい"
                          />
                          <div
                            class="invalid-feedback"
                            v-if="hasError('furigana', 'personal')"
                          >
                             
                            {{ getErrorMessage("furigana", "personal") }}
                          </div>
                        </div>

                        <div class="col-md-12 mb-30">
                          <label class="cstm-label">
                            性別
                            <span class="span-badge ml-2">必須</span>
                          </label>
                          <div class="d-flex">
                            <div class="custom-control custom-radio ml-2">
                              <input
                                class="custom-control-input"
                                type="radio"
                                name="gender"
                                v-model="profile.gender"
                                id="exampleRadios3"
                                value="指定なし"
                                checked
                              />
                              <label
                                class="custom-control-label cstm-label"
                                for="exampleRadios3"
                                >指定なし</label
                              >
                            </div>
                            <div class="custom-control custom-radio ml-2">
                              <input
                                class="custom-control-input"
                                type="radio"
                                name="gender"
                                v-model="profile.gender"
                                id="exampleRadios1"
                                value="男性"
                              />
                              <label
                                class="custom-control-label cstm-label"
                                for="exampleRadios1"
                                >男性</label
                              >
                            </div>
                            <div class="custom-control custom-radio ml-2">
                              <input
                                class="custom-control-input"
                                type="radio"
                                name="gender"
                                v-model="profile.gender"
                                id="exampleRadios2"
                                value="女性"
                              />
                              <label
                                class="custom-control-label cstm-label"
                                for="exampleRadios2"
                                >女性</label
                              >
                            </div>
                          </div>
                          <div
                            class="invalid-feedback"
                            v-if="hasError('gender', 'personal')"
                          >
                             
                            {{ getErrorMessage("gender", "personal") }}
                          </div>
                        </div>
                        <div class="col-md-12 mb-30">
                          <label class="cstm-label">
                            生年月日
                            <span class="span-badge ml-2">必須</span>
                          </label>
                          <div class="d-flex justify-content-between">
                            <select
                              class="form-control mr-2  pristine-untouched"
                              v-bind:class="{
                                'is-invalid': hasError('year', 'personal'),
                              }"
                              name="year"
                              v-model="birth_date.year"
                              v-validate="'required'"
                              data-vv-as="生年月日"
                            >
                              <option value>年</option>
                              <option
                                v-for="year in years"
                                v-bind:key="year"
                                v-bind:value="year"
                              >
                                {{ year }}
                              </option>
                            </select>
                            <select
                              class="form-control mr-2 "
                              v-bind:class="{
                                'is-invalid': hasError('month', 'personal'),
                              }"
                              name="month"
                              v-model="birth_date.month"
                              v-validate="'required'"
                              data-vv-as="生年月日"
                            >
                              <option value>月</option>
                              <option
                                v-for="month in months"
                                v-bind:key="month"
                                v-bind:value="month"
                              >
                                {{ month }}
                              </option>
                            </select>
                            <select
                              class="form-control "
                              v-bind:class="{
                                'is-invalid': hasError('day', 'personal'),
                              }"
                              name="day"
                              v-model="birth_date.day"
                              v-validate="'required'"
                              data-vv-as="生年月日"
                            >
                              <option value>日</option>
                              <option
                                v-for="day in days"
                                v-bind:key="day"
                                v-bind:value="day"
                              >
                                {{ day }}
                              </option>
                            </select>
                          </div>
                          <div
                            class="invalid-feedback"
                            v-if="
                              hasError('day', 'personal') ||
                                hasError('month', 'personal') ||
                                hasError('year', 'personal')
                            "
                          >
                             
                            生年月日は必須項目です
                          </div>
                          <div
                            class="invalid-feedback"
                            v-if="hasError('birth_date', 'personal')"
                          >
                            <!-- <span class="icon-error invalid-date">!</span> -->
                            <span style="font-size:;text-align:initial">{{
                              getErrorMessage("birth_date", "personal")
                            }}</span>
                          </div>
                        </div>
                        <div class="col-md-12 mb-30">
                          <label class="cstm-label">
                            居住地
                            <span class="span-badge ml-2">必須</span>
                          </label>
                          <select
                            class="form-control"
                            v-bind:class="{
                              'is-invalid': hasError('residence', 'personal'),
                            }"
                            name="residence"
                            v-model="profile.residence"
                            v-validate="'required'"
                            data-vv-as="居住地"
                          >
                            <option value>選択</option>
                            <option
                              v-for="residence in data.residence"
                              v-bind:key="residence._id"
                              v-bind:value="residence._id"
                            >
                              {{ residence.title }}
                            </option>
                          </select>
                          <div
                            class="invalid-feedback"
                            v-if="hasError('residence', 'personal')"
                          >
                             
                            {{ getErrorMessage("residence", "personal") }}
                          </div>
                        </div>
                        <div class="col-md-12 mb-30">
                          <p>
                            ※メールアドレスはこのページでは変更できません。<br/>「設定」画面から変更できます。
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
                <!-- ends custom-form-block -->
              </b-modal>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </div>
  <!-- ends profile-detail -->
</template>

<script>
/* eslint-disable */
import ProfileHeader from "@/components/header.vue";
import Api from "@/config/api";
// eslint-disable-next-line
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import swal from "sweetalert";
import logo from "../assets/Group300.png";
import Footer from "./Footer.vue";
import Unsubscribe from "./Unsubscribe.vue";
import Academic from "./Academic.vue";
import Employment from "./Employment.vue";
import Loader from "./Loader.vue";
export default {
  components: {
    ProfileHeader,
    Footer,
    Unsubscribe,
    Academic,
    Employment,
    Loader,
  },
  data() {
    return {
      data: {},
      server_errors: {},
      selectedCursor: "pointer",
      tempPersonalData: {},
      isPersonelEdit: true,
      years: [],
      months: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      days: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
      ],
      birth_date: {
        year: "",
        month: "",
        day: "",
      },
      maintenance_msg: "",
      show_msg: false,
    };
  },
  watch: {
    // eslint-disable-next-line
    // eslint-disable-next-line
    "birth_date.year": function() {
      this.birthDateChanged();
    },
    // eslint-disable-next-line
    "birth_date.month": function() {
      this.birthDateChanged();
    },
    // eslint-disable-next-line
    "birth_date.day": function() {
      this.birthDateChanged();
    },
  },
  computed: {
    ...mapGetters({
      profile: "getProfile",
      selectBoxValues: "getSelectBoxValues",
    }),
    birthDate() {
      return moment(this.profile.birth_date).format("YYYY/MM/DD");
    },
  },
  methods: {
    ...mapActions({
      setProfile: "setProfile",
      selectBox: "selectBoxValues",
    }),
    formatDate(date, format = "YYYY-MM-DD") {
      // console.log(date);
      return moment(date)
        .utc()
        .format(format);
    },
    hasError(field, scope = null) {
      return (
        field in this.server_errors || this.errors.first(`${scope}.${field}`)
      );
    },
    getErrorMessage(field, scope = null) {
      if (field in this.server_errors) return this.server_errors[field].msg;
      else if (this.errors.first(`${scope}.${field}`)) {
        return this.errors.first(`${scope}.${field}`);
      }
      return null;
    },
    getResidence(id) {
      if (this.data.residence) {
        const result = this.data.residence.find(({ _id }) => _id === id);
        if (result) return result.title;
      }
      return "";
    },
    checkDiff(actualData, changedData) {
      for (let key of Object.keys(changedData)) {
        if (actualData[key] !== changedData[key]) {
          return true;
        }
      }
      return false;
    },
    async savePersonal(event) {
      const personalData = {
        full_name: this.profile.full_name,
        last_name: this.profile.last_name,
        furigana: this.profile.furigana,
        last_furigana: this.profile.last_furigana,
        gender: this.profile.gender,
        birth_date: this.profile.birth_date,
        residence: this.profile.residence,
        // phone: this.profile.phone,
      };
      let tempDate = this.profile.birth_date;
      const changedData = {
        ...personalData,
        birth_date: tempDate,
      };

      // tempDate = new Date(this.tempPersonalData.birth_date);
      tempDate = this.tempPersonalData.birth_date;
      const actualData = {
        ...this.tempPersonalData,
        birth_date: tempDate,
      };

      if (this.checkDiff(actualData, changedData)) {
        event.preventDefault();
        let res = await this.confirmSave();
        if (res) {
          const dataForm = new FormData();
          Object.keys(personalData).forEach((key) =>
            dataForm.append(key, personalData[key])
          );
          // if (this.profile.image_name && this.profile.selectedFile) {
          //   dataForm.append('image', this.profile.selectedFile, this.profile.image_name);
          // }
          await this.save(dataForm, "personal");
        }
      } else {
        this.cancel("personal");
      }
    },
    async confirmSave() {
      let res = await swal({
        title: "情報を更新しますか？",
        text: `登録企業への公開情報が更新されます。\n 書類（履歴書・職務経歴書等）をアップロードまたは更新した場合、\n 登録企業すべてに同じ書類が公開されます。`,
        icon: "warning",
        className: "custom-swal",
        closeOnClickOutside: false,
        buttons: {
          cancel: "キャンセル",
          ok: {
            text: "更新する",
            value: true,
            visible: true,
            closeModal: false,
          },
        },
      });
      return res;
    },
    async save(data, url) {
      const check = await this.$validator.validateAll(url);
      if (check) {
        try {
          const token = await this.$auth.getToken();
          const headers = {
            Authorization: `Bearer ${token}`,
          };
          await this.axios({
            method: "post",
            data,
            url: Api.url(Api.endpoints[url]),
            headers: headers,
          });
          if (url === "personal") {
            this.tempPersonalData.full_name = this.profile.full_name;
            this.tempPersonalData.last_name = this.profile.last_name;
            this.tempPersonalData.furigana = this.profile.furigana;
            this.tempPersonalData.last_furigana = this.profile.last_furigana;
            this.tempPersonalData.birth_date = this.profile.birth_date;
            this.tempPersonalData.residence = this.profile.residence;
            // this.tempPersonalData.phone = this.profile.phone;
            this.tempPersonalData.gender = this.profile.gender;
            this.isPersonelEdit = true;
            this.$refs.modal.hide();
            // swal("", "更新しました。", "success");
          }
          let content = document.createElement("span");
          content.innerHTML = `<p style="font-weight:bold">情報を更新しました。</p>`;
          swal({
            title: "",
            content: content,
            className: "custom-swal4",
            icon: logo,
            buttons: {
              ok: "OK",
            },
          });
          this.clearErrors();
          return true;
        } catch (error) {
          if (error && error.response && error.response.status === 422) {
            this.server_errors = error.response.data;
          } else if (
            (error.response && error.response.status === 503) ||
            (error.response && error.response.status === 401)
          ) {
            this.$router.push({ name: "Logout" });
          } else {
            swal("", "Something Went Wrong", "error");
          }
          return false;
        } finally {
          swal.close();
        }
      } else {
        swal.close();
      }
    },
    clearErrors() {
      // clear errors
      this.errors.clear();
      this.server_errors = {};
    },
    clearServerError(name) {
      // clear server error of resume on file change
      const { [name]: exclude, ...newServerError } = this.server_errors;
      this.server_errors = { ...newServerError };
    },
    showModal() {
      this.tempPersonalData.full_name = this.profile.full_name;
      this.tempPersonalData.last_name = this.profile.last_name;
      this.tempPersonalData.furigana = this.profile.furigana;
      this.tempPersonalData.last_furigana = this.profile.last_furigana;
      this.tempPersonalData.birth_date = this.profile.birth_date;
      this.tempPersonalData.residence = this.profile.residence;
      // this.tempPersonalData.phone = this.profile.phone;
      this.tempPersonalData.gender = this.profile.gender;
      const birthDate = new Date(this.profile.birth_date);
      this.birth_date.year = birthDate.getFullYear();
      this.birth_date.month = birthDate.getMonth() + 1;
      if (this.birth_date.month < 10 && this.birth_date.month > 0) {
        this.birth_date.month = `0${this.birth_date.month}`;
      }
      this.birth_date.day = birthDate.getDate();
      if (this.birth_date.day < 10 && this.birth_date.day > 0) {
        this.birth_date.day = `0${this.birth_date.day}`;
      }
      this.$refs.modal.show();
    },
    cancel(group) {
      if (group === "personal") {
        this.$refs.modal.hide();
        this.profile.full_name = this.tempPersonalData.full_name;
        this.profile.last_name = this.tempPersonalData.last_name;
        this.profile.furigana = this.tempPersonalData.furigana;
        this.profile.last_furigana = this.tempPersonalData.last_furigana;
        this.profile.birth_date = this.tempPersonalData.birth_date;
        this.profile.residence = this.tempPersonalData.residence;
        // this.profile.phone = this.tempPersonalData.phone;
        this.profile.gender = this.tempPersonalData.gender;
      }
      this.clearErrors();
    },
    birthDateChanged() {
      this.profile.birth_date = `${this.birth_date.year}/${this.birth_date.month}/${this.birth_date.day}`;
    },
    initBirthDate() {
      const d = new Date();
      const n = d.getFullYear();
      let j = 0;
      for (let i = n - 70; i <= n - 18; i += 1) {
        this.years[j] = i;
        j += 1;
      }
    },
    scrollToTop() {
      const element = document.getElementsByClassName("main-wrapper")[0];
      if (element) {
        element.scrollIntoView();
        // console.log(parent.offsetTop - (parent.offsetHeight * 2));
        // console.log(parent.offsetTop);
        // console.log(document.getElementsByClassName('form-detail')[0]);
        // document.getElementsByClassName('form-detail')[0].scrollTop =
        // parent.offsetTop - (parent.offsetHeight * 2);
      }
    },
    async checkMaintenaceMsg() {
      try {
        const response = await this.axios({
          method: "get",
          url: Api.url(Api.endpoints.SITE_INFO),
        });

        if (response.data) {
          const resData = response.data;
          if (resData.data.show_msg == true) {
            this.show_msg = resData.data.show_msg;
            this.maintenance_msg = resData.data.maintenance_msg;
          }
        } else {
          this.show_msg = false;
          this.show_msg = "";
        }
      } catch (error) {
        this.show_msg = false;
        this.maintenance_msg = "";
      }
    },
  },
  async mounted() {
    this.initBirthDate();
    this.checkMaintenaceMsg();
  },
  async created() {
    this.scrollToTop();
    // console.log(await this.$auth.isAuthenticated());
    Object.keys(this.profile).length === 0 && (await this.setProfile());
    Object.keys(this.selectBoxValues).length === 0 && (await this.selectBox());

    this.data = this.selectBoxValues;
    // try {
    //   const token = await this.$auth.getToken();
    //   const response = await this.axios({
    //     method: "get",
    //     url: Api.url(`${Api.endpoints.selectBoxValues}`),
    //     headers: {
    //       Authorization: `Bearer ${token}`,
    //     },
    //   });
    //   // let events = await this.axios({method: "get", url: Api.url(`${Api.endpoints.events}?is_test_user=${this.profile.test_user}`)});
    //   // if(events){
    //   //   this.events = events.data;
    //   //   this.isEvents = true;
    //   // }

    //   this.data = response.data.data;
    // } catch (error) {
    //   console.log(error);
    //   this.$router.push({ name: "Logout" });
    // }
  },
};
</script>
<style scoped>
@import url("../assets/css/shared.css");
.form-control.is-valid{
  background-image: none;
}
.form-control.is-invalid{
  background-image: none;
}
>>> .sharingTitle {
  margin-top: 5px;
  color: black !important;
  font-weight: 600;
}
</style>
